import React from 'react';

import '@eika/button-style/src/button.scss';
import { IconTypes } from '@eika/icon';
import { Label } from '@eika/label';
import { LinkCard } from '@eika/link-panel';

import type { Account, DebitCardDetailEndpoint } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';

import './AccountCards.scss';

interface Props {
    cards: DebitCardDetailEndpoint[];
    account: Account | undefined;
}

const AccountCardsApp: React.FC<Props> = ({ cards, account }) => {
    const translated = useTranslation();
    return (
        <div className="related-cards-container">
            <h2>{translated.accountDetails.card}</h2>
            {cards.map((debitCard) => (
                <LinkCard
                    className="debit-card-links__list-item"
                    icon={IconTypes.BANKKORT_DYN}
                    labels={debitCard.ownCard ? undefined : <Label size="small" text={debitCard.name} type="warning" />}
                    key={debitCard.url}
                    title={account?.alias ?? debitCard.name}
                    url={debitCard.url}
                />
            ))}
        </div>
    );
};

export default AccountCardsApp;
